import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

import { admin_cse } from "../../../../config/roles";
import { FeatureGate } from "../../../Common/FeatureGate/FeatureGate";
import { isAuthorized } from "../../../../redux/actions/auth";
import { OPERATIONAL_RESTRICT_PATIENT_SCHEDULING } from "../../../../constants/featureFlags";

import ChangePatientEmailCard from "./Admin/ChangePatientEmailCard";
import ChangePatientPracticeCard from "./Admin/ChangePatientPracticeCard";
import OverridePatientAutocharge from "./Admin/OverridePatientAutocharge";
import ResetPatientPasswordCard from "./Admin/ResetPatientPasswordCard";
import RestrictPatientSchedulingCard from "./Admin/RestrictPatientSchedulingCard";
import VerifyPatientEmailCard from "./Admin/VerifyPatientEmailCard";

const MemberProfileAdmin = (props) => {
  const privateFlags = useSelector((state) => state.flags.privateFlags);
  const privateFlagsHaveLoaded = useSelector((state) => state.flags.privateFlagsHaveLoaded);

  useEffect(() => {
    if (!isAuthorized(admin_cse)) {
      props.history.push("/app/home");
    }
  }, []);

  return (
    <div className="AdminTab">
      <div className="mt-3 mb-3">
        <ChangePatientEmailCard
          patientDetails={props.patientDetails}
          updateState={props.updateState}
        />
      </div>
      <div className="mb-3">
        <VerifyPatientEmailCard
          patientDetails={props.patientDetails}
          updateState={props.updateState}
        />
      </div>
      <div className="mb-3">
        <ResetPatientPasswordCard
          patientDetails={props.patientDetails}
          updateState={props.updateState}
        />
      </div>
      <div className="mb-3">
        <ChangePatientPracticeCard
          patientDetails={props.patientDetails}
          updateState={props.updateState}
        />
      </div>
      <div className="mb-3">
        <OverridePatientAutocharge
          patientDetails={props.patientDetails}
          updateState={props.updateState}
          selectedTabChangeHandler={props.selectedTabChangeHandler}
        />
      </div>
      <FeatureGate
        defaultFlagBehavior={false}
        flagName={OPERATIONAL_RESTRICT_PATIENT_SCHEDULING}
        enabled={privateFlags?.[OPERATIONAL_RESTRICT_PATIENT_SCHEDULING]}
        hasLoaded={privateFlagsHaveLoaded}
        alternateFlagDisabledBehavior={<></>}
      >
        <div className="mb-3" ref={props?.adminFocusRef}>
          <RestrictPatientSchedulingCard
            patientDetails={props.patientDetails}
            refetchDetails={props.refetchDetails}
          />
        </div>
      </FeatureGate>
    </div>
  );
};

export default withRouter(MemberProfileAdmin);
